module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Battleships of the World")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../style/9781473871489.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapname1"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v(" he battle squadrons of the Royal Navy, assembled at Spithead for the Naval Review of 1914, epitomised the armoured battleship at the height of its prestige. The long columns of majestic vessels represented Britain’s long-held mastery of the sea which had enabled the building of an empire, the defeat of Napoleon and the commercial supremacy of the past century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The very names of the ships emphasised the traditions of the service: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ajax, Neptune, Conqueror, Orion, Colossus")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thunderer")]), _vm._v(" were all named after ships which had fought in the battle line at Trafalgar. An "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Audacious")]), _vm._v(" had fought at Aboukir Bay (the Battle of the Nile), where a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vanguard")]), _vm._v(" had been Nelson’s flagship, while another "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vanguard")]), _vm._v(" and a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hercules")]), _vm._v(" had fought the Armada. There had been a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monarch")]), _vm._v(" at Copenhagen, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Superb")]), _vm._v(" at Algeciras. A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Centurion")]), _vm._v(" had been Anson’s flagship for his epic voyage around the world and a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bellerophon")]), _vm._v(" had seen the surrender of Napoleon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now all of these names were borne by massive armoured ships, armed with guns of at least 12-inch calibre, any one of which could have reduced to matchwood an entire fleet of Nelson’s day. Among vessels nearing completion were a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Royal Sovereign")]), _vm._v(", a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Warspite")]), _vm._v(" and a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revenge")]), _vm._v(", inheritors of some of the most famous names, while the most famous of all "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victory")]), _vm._v(", launched in 1765, was then still afloat in Portsmouth harbour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreadnought")]), _vm._v(" herself was named after a ship which had been in Drake’s squadron in Cadiz in 1587 and in Howard’s fleet in the Channel the following year. A second ship of the name had fought in the Dutch wars of the seventeenth century, a third against the French at Barfleur and Cape Passaro. Yet another had been Collingwood’s flagship in the blockade of Cadiz in 1805 and had fought at Trafalgar. Now the name was given to a new generation of fast, powerful armoured battleships. In 1914 the expectation was that the great issues of the war at sea would still be decided, as they had been for some four centuries, by the battle fleets. That certainty was shaken by the inconclusive nature of the gun duel at Jutland and by the vulnerability of the great ships to mine and torpedo. Finally, it was to be shattered by the aircraft which wrought such destruction at Taranto and Pearl Harbor, which sank Force Z and eventually overwhelmed the Japanese leviathans "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yamato")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Musashi")]), _vm._v(". By 1945 it was clear that the end of the battleship era had come and the great ships, which were scrapped in the aftermath of the Second World War, were not replaced.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img7.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victory")]), _vm._v(", afloat in Portsmouth harbour.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71592151","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_intro.vue
// module id = 72
// module chunks = 0